import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.SUB_CATEGORIES_LIST_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.SUB_CATEGORIES_LIST_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const subCategoriesList = () => {
  return async (dispatch) => {
    dispatch({ type: CONST.SUB_CATEGORIES_LIST_REQUEST });

    axios
      .get('/categories-types')
      .then((response) => {
        handleResponse(dispatch, response);
      })
      .catch((error) => console.error(error));
  };
};
